/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';
import IconSvg from 'components/Core/IconSvg';

import { getCombinedClassNames } from 'utils/style';
import themConfigs from 'config/theme';

const fullConfig = { theme: themConfigs };

const IconElem = styled(IconSvg)`
  top: 14px;
  left: 10px;

  @media (min-width: ${fullConfig.theme.screens.md}) {
    top: 28px;
    left: 25px;
  }
`;

const ButtonElem = styled.button.attrs(() => {
  const classNamesToAdd = [
    'relative',
    'flex',
    'items-center',
    'w-full',
    'p-3',
    'pl-10',
    'md:p-6',
    'md:pl-16',
    'md:focus:pl-15',
    'focus:outline-none',
    'transition-spacing',
    'ease-out',
    'duration-150',
  ];
  return {
    className: getCombinedClassNames(classNamesToAdd),
  };
})`
  -webkit-tap-highlight-color: transparent;
`;

const Content = styled.div.attrs(() => {
  const classNamesToAdd = ['pr-3', 'pl-10', 'pb-4', 'md:pb-8', 'md:pl-16', 'md:-mt-2'];
  return {
    className: getCombinedClassNames(classNamesToAdd),
  };
})`
  a {
    cursor: pointer;
    color: ${fullConfig.theme.extend.colors.primary.default};
    transition-property: color;
    transition-duration: 200ms;
    transition-timing-function: ease-in-out;
    &:hover {
      opacity: 0.8;
    }
    &:focus {
      opacity: 0.6;
      outline: none;
    }
  }
`;

export { IconElem, ButtonElem, Content };
